import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useResetPasswordVerify } from '../hooks/tanstack/useAuthHook';
import { useGetRouteParams } from '../hooks/tanstack/useUtilsHook';
import routes from '../routes';

function PasswordResetVerify() {
  const { mutate: verifyResetPasswordToken } = useResetPasswordVerify({
    onSuccess: (data) => {
      navigate(routes.resetPassword.setPassword + '?token=' + token, {
        replace: true,
      });
    },
    onError: (error) => {
      navigate(routes.resetPassword.fail, { replace: true });
    },
  });

  // Get the token from the magic link
  const { token } = useGetRouteParams();
  const navigate = useNavigate();

  // Send token to server to verify

  useEffect(() => {
    if (token) {
      const data = {
        token,
      };

      verifyResetPasswordToken({ data });
    }
  }, [token]);

  return <div />;
}

export default PasswordResetVerify;
